import { render, staticRenderFns } from "./AssignApps.vue?vue&type=template&id=1a0baecc&scoped=true"
import script from "./AssignApps.vue?vue&type=script&lang=js"
export * from "./AssignApps.vue?vue&type=script&lang=js"
import style0 from "./AssignApps.vue?vue&type=style&index=0&id=1a0baecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0baecc",
  null
  
)

export default component.exports